import { observable } from 'mobx';
import axios from 'axios'
import { loginStore } from  '../../stores'

import { apiUrl } from '../../config'

class SettingsStore {
  @observable error = ''

  saveMyInfo = (varFirstName, varLastName, varSurName , varTel, varTel2, varEmail) =>{
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&saveMyInfo=true&phone=${varTel}&varFirstName=${varFirstName}&varLastName=${varLastName}&varSurName=${varSurName}&varTel2=${varTel2}&varEmail=${varEmail}`)
      .then( response => {
        loginStore.getMyInfo(varTel)
      })
      .catch( err => {
        this.error = err
        console.log(err)
      })
  }
}

export default new SettingsStore();
